import { render, staticRenderFns } from "./QuestionAdd.vue?vue&type=template&id=3a352bc4&scoped=true&"
import script from "./QuestionAdd.vue?vue&type=script&lang=js&"
export * from "./QuestionAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a352bc4",
  null
  
)

export default component.exports